import { NgModule, Injectable } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ChartsPageComponent } from "./charts-page/charts-page.component";
import {
  Routes,
  RouterModule,
  CanDeactivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { IconsModule } from "@va/core-library/icons";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { ChartPlotterModule } from "../chart-plotter/chart-plotter.module";
import { ChartsFiltersComponent } from "./charts-filters/charts-filters.component";
import { SharedModule } from "../shared/shared.module";
import { ChartsPlotterContainerComponent } from "./charts-plotter-container/charts-plotter-container.component";
import { ChartsTickerModalComponent } from "./charts-ticker-modal/charts-ticker-modal.component";
import { ChartsLIModalComponent } from "./charts-li-modal/charts-li-modal.component";
import { EstimatesFilterComponent } from "./estimates-filter/estimates-filter.component";
import { CreateNewChartsWizardComponent } from "./create-new-charts-wizard/create-new-charts-wizard.component";
import { CreateNewChartsBaseComponent } from "./create-new-charts-base/create-new-charts-base.component";
import { EditChartsTickerComponent } from "./edit-charts-ticker/edit-charts-ticker.component";
import { EditChartsLiComponent } from "./edit-charts-li/edit-charts-li.component";
import { CreateNewChartsNamingComponent } from "./create-new-charts-naming/create-new-charts-naming.component";
import { ChartsYearTypeFilterComponent } from "./charts-year-type-filter/charts-year-type-filter.component";
import { ShareChartComponent } from "./share-chart/share-chart.component";
import { EditNameInputComponent } from "./edit-name-input/edit-name-input.component";
import { PeriodFilterModule } from "@va/core-library/period-filter";
import { CurrencySelectModule } from "@va/core-library/currency-select";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzRadioModule } from "ng-zorro-antd/radio";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzStepsModule } from "ng-zorro-antd/steps";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzAutocompleteModule } from "ng-zorro-antd/auto-complete";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzPopoverModule } from "ng-zorro-antd/popover";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzButtonModule } from "ng-zorro-antd/button";

import { ButtonModule } from "@va/core-library/button";

export function defaultUrl() {
  window.location.href = `${window.caUrl}/app`;
  return [];
}

@Injectable({
  providedIn: "root",
})
export class CanDeactivateGuard implements CanDeactivate<ChartsPageComponent> {
  canDeactivate(
    component: ChartsPageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot,
  ): boolean {
    if (component.hasUnsavedData) {
      if (!component.promptModal) {
        component.promptToSave(nextState, null);
      }
      return false;
    }
    return true;
  }
}

const chartRoutes: Routes = [
  {
    path: ":chartId",
    component: ChartsPageComponent,
    data: {
      title: "Charts Page",
    },
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: "",
    component: ChartsPageComponent,
    data: {
      title: "Charts Page",
    },
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: "**",
    redirectTo: "/home",
  },
];

@NgModule({
  imports: [RouterModule.forChild(chartRoutes)],
  exports: [RouterModule],
})
export class ChartsPageRoutingModule {}
@NgModule({
  declarations: [
    ChartsPageComponent,
    ChartsFiltersComponent,
    ChartsPlotterContainerComponent,
    ChartsTickerModalComponent,
    ChartsLIModalComponent,
    EstimatesFilterComponent,
    CreateNewChartsWizardComponent,
    CreateNewChartsBaseComponent,
    EditChartsTickerComponent,
    EditChartsLiComponent,
    CreateNewChartsNamingComponent,
    ChartsYearTypeFilterComponent,
    ShareChartComponent,
    EditNameInputComponent,
  ],
  imports: [
    CommonModule,
    ChartsPageRoutingModule,
    IconsModule,
    FormsModule,
    ButtonModule,
    SharedModule,
    ChartPlotterModule,
    ReactiveFormsModule,
    PeriodFilterModule,
    CurrencySelectModule,
    NzSkeletonModule,
    NzModalModule,
    NzSpinModule,
    NzRadioModule,
    NzSelectModule,
    NzStepsModule,
    NzDropDownModule,
    NzInputModule,
    NzAutocompleteModule,
    NzTableModule,
    NzGridModule,
    NzPopoverModule,
    NzCheckboxModule,
    NzIconModule,
    NzSpinModule,
    NzButtonModule,
  ],
  bootstrap: [
    ChartsTickerModalComponent,
    ChartsLIModalComponent,
    CreateNewChartsWizardComponent,
    ShareChartComponent,
  ],
  exports: [EstimatesFilterComponent],
})
export class ChartsPageModule {}
